const BUILD_INFO = Object.freeze({
  "version": "4.7.197",
  "buildId": "20261103T203638Z",
  "generatedAt": "2026-11-03T20:36:38.136Z",
  "gitSha": null,
  "source": "server"
});

export default BUILD_INFO;
export const APP_VERSION = BUILD_INFO.version;
export const BUILD_ID = BUILD_INFO.buildId;
export const BUILD_GENERATED_AT = BUILD_INFO.generatedAt;
export const BUILD_GIT_SHA = BUILD_INFO.gitSha;
export const BUILD_SOURCE = BUILD_INFO.source;
export const BUILD_LABEL = `v${APP_VERSION} | build ${BUILD_ID}`;
